export default "/assets/site/images/polhy_katalin.png?d2e73d40d6e380d036ffc27c0bb742ba";